import { Banner } from '../banner/Banner';

const bannerContent = {
    header: 'Granka, granka, granka!',
    text: 'Opplev ekte kanarisk sjarm i Puerto de la Cruz.',
    callToAction: 'Se reisetips',
    link: 'https://www.finn.no/reise/artikler/solreiser/reisetips-til-puerto-de-la-cruz-pa-tenerife',
    img: {
        src: 'https://finn-content-hub.imgix.net/bilder/GettyImages-590142422.jpg?auto=format,compress&crop=focalpoint&fit=crop&fp-x=0.5&fp-y=1.5&w=470&h=300',
        width: 470,
        height: 300,
        alt: '',
    },
};

export const FrontpageBanner = () => {
    const { header, text, callToAction, link, img } = bannerContent;

    return <Banner header={header} text={text} callToAction={callToAction} link={link} imgType="img" img={img} />;
};
